import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

/** Half the circumference of the earth in Web Mercator meters. */
const WEB_MERCATOR_EXTENT = 20037508.342789244;

const mercatorTileBounds = (x: number, y: number, z: number) => {
  const tileSize = (2 * WEB_MERCATOR_EXTENT) / 2 ** z;
  const west = -WEB_MERCATOR_EXTENT + x * tileSize;
  const north = WEB_MERCATOR_EXTENT - y * tileSize;
  return { west, south: north - tileSize, east: west + tileSize, north };
};

export const mptSvpAerialYears = {
  aerialSR2023: 'orto_2023',
  aerialSR2020: 'orto_2020',
  aerialSR2016: 'orto_2016',
} as const;

type MptSvpAerialYears = keyof typeof mptSvpAerialYears;
type ServiceName = typeof mptSvpAerialYears[MptSvpAerialYears];

const mptSvpAerialLayer = (service: ServiceName = mptSvpAerialYears.aerialSR2023) =>
  new TileLayer({
    id: `mpt-svp-aerial-${service}`,
    getTileData: async ({ index: { x, y, z } }) => {
      const { east, south, north, west } = mercatorTileBounds(x, y, z);
      const url = `https://mpt.svp.sk/server/rest/services/podkladove_mapy/${service}/MapServer/export?bbox=${west},${south},${east},${north}&bboxSR=3857&imageSR=3857&size=256,256&format=jpg&transparent=false&f=image`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export { mptSvpAerialLayer };
